function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#f6f3f1;}.cls-3{fill:#e2dbd7;}.cls-4{fill:#c9d3e2;}.cls-5{fill:#3b4e85;}.cls-10,.cls-15,.cls-33,.cls-34,.cls-6{mix-blend-mode:multiply;}.cls-6{fill:url(#linear-gradient);}.cls-7{fill:#242253;}.cls-10,.cls-7{opacity:0.5;}.cls-8{fill:#4d51a2;}.cls-9{fill:#313d69;}.cls-10{fill:url(#linear-gradient-2);}.cls-11,.cls-12,.cls-20,.cls-21,.cls-24,.cls-25{fill:none;}.cls-11{stroke:#3b4e85;}.cls-11,.cls-12,.cls-20,.cls-21,.cls-24{stroke-miterlimit:10;}.cls-11,.cls-12,.cls-20,.cls-21{stroke-width:0.5px;}.cls-12,.cls-24,.cls-25{stroke:#221e3f;}.cls-13{fill:#a4a9d1;}.cls-14{fill:#8fa1c2;}.cls-15,.cls-24,.cls-25,.cls-30,.cls-33,.cls-34{opacity:0.3;}.cls-15{fill:url(#linear-gradient-3);}.cls-16{fill:#c7cfdc;}.cls-17{fill:#dae4f7;}.cls-18{fill:#006373;}.cls-19{fill:#329ea6;}.cls-20{stroke:url(#linear-gradient-4);}.cls-21{stroke:#7998db;}.cls-22{fill:#f05b5c;}.cls-23,.cls-26{opacity:0.2;}.cls-23{fill:url(#linear-gradient-5);}.cls-24,.cls-25{stroke-width:0.23px;}.cls-25{stroke-linecap:round;stroke-linejoin:round;}.cls-26{fill:url(#linear-gradient-8);}.cls-27{fill:#f5eed3;}.cls-28{fill:#0e1d38;opacity:0.1;}.cls-29{fill:#fff;}.cls-30{fill:#7998db;}.cls-31{fill:#4da878;}.cls-32{fill:#7bc99d;}.cls-33{fill:url(#linear-gradient-11);}.cls-34{fill:url(#linear-gradient-12);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 193.2,
  y1: 222.02,
  x2: 240.35,
  y2: 185.41,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#4d51a2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#4d51a2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 207.85,
  y1: 112.68,
  x2: 221.16,
  y2: 92.72,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#4d51a2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4d51a2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 206.72,
  y1: 243.56,
  x2: 238.11,
  y2: 243.56,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 84.15,
  y1: 113.28,
  x2: 143.48,
  y2: 113.28,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#4d51a2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#4d51a2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4d51a2",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: 213.44,
  y1: 197.87,
  x2: 235.57,
  y2: 173.41,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#671e22"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#671e22",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: 197.39,
  y1: 147.1,
  x2: 236.17,
  y2: 147.1,
  xlinkHref: "#linear-gradient-5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-11",
  x1: 262.62,
  y1: 251.28,
  x2: 302.56,
  y2: 251.28,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-12",
  x1: 283.92,
  y1: 251.28,
  x2: 302.56,
  y2: 251.28,
  xlinkHref: "#linear-gradient-2"
}));

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Asset 10");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "cls-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M263.43,48.4c-18.1-5.85-54.6-4.95-84.78-31.5S105-3.22,77.47,24.31L13.39,113.2C-7.29,145.61-1.39,182,13.39,213l32.93,63.53,149.26.57s82.87,13,102.84,0a127.26,127.26,0,0,0,58-106.82C356.39,100,330.36,70.05,263.43,48.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M46.2,276.7c0,.33.74.73.94,1,18,24.94,55.6,33.62,125.41,33.62S281.59,298,298,277.7c.21-.26,1-.67.94-1Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 64.16,
  y: 60.23,
  width: 102.07,
  height: 226.88
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 166.23,
  y: 60.23,
  width: 82.69,
  height: 226.88
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "64.16 213.88 248.92 213.88 248.92 287.11 166.23 239.95 64.16 239.95 64.16 213.88"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "183.42 159.8 190.63 240.51 238.34 240.51 230.29 159.8 183.42 159.8"
}), /*#__PURE__*/React.createElement("rect", {
  x: 183.42,
  y: 112.93,
  width: 46.87,
  height: 46.87
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "252.48 82.14 205.61 82.14 183.42 112.93 230.29 112.93 252.48 82.14"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "252.48 82.14 205.61 82.14 183.42 112.93 230.29 112.93 252.48 82.14"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-10",
  points: "252.48 82.14 205.61 82.14 183.42 112.93 230.29 112.93 252.48 82.14"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 148.47,
  y1: 249.38,
  x2: 80.24,
  y2: 249.38
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 148.47,
  y1: 257.71,
  x2: 80.24,
  y2: 257.71
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 148.47,
  y1: 266.03,
  x2: 80.24,
  y2: 266.03
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 148.47,
  y1: 274.35,
  x2: 80.24,
  y2: 274.35
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M206.67,291.11V250.88a4.08,4.08,0,0,1,3.86-4.27h28a4.08,4.08,0,0,1,3.87,4.27v40.23"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 206.67,
  y1: 266.86,
  x2: 242.36,
  y2: 266.86
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 212.2,
  y1: 250.88,
  x2: 242.36,
  y2: 285.16
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M176.5,291.11V250.88a4.09,4.09,0,0,1,3.87-4.27h28a4.09,4.09,0,0,1,3.87,4.27v40.23"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 176.5,
  y1: 266.86,
  x2: 212.2,
  y2: 266.86
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 176.5,
  y1: 250.88,
  x2: 206.67,
  y2: 285.16
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-13",
  x: 173.99,
  y: 240.51,
  width: 65.85,
  height: 6.1
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-14",
  x: 176.76,
  y: 240.51,
  width: 65.85,
  height: 6.1
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-15",
  x: 176.76,
  y: 240.51,
  width: 65.85,
  height: 6.1
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-16",
  x: 173.99,
  y: 240.51,
  width: 37.7,
  height: 6.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-17",
  cx: 98.99,
  cy: 230.46,
  r: 3.91
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-17",
  cx: 84.15,
  cy: 230.46,
  r: 3.91
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-17",
  cx: 113.82,
  cy: 230.46,
  r: 3.91
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-17",
  cx: 143.48,
  cy: 230.46,
  r: 3.91
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-17",
  cx: 128.65,
  cy: 230.46,
  r: 3.91
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 91.57,
  y1: 206.25,
  x2: 91.57,
  y2: 147.6
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 136.07,
  y1: 206.25,
  x2: 136.07,
  y2: 147.6
}), /*#__PURE__*/React.createElement("rect", {
  x: 80.24,
  y: 80.2,
  width: 67.15,
  height: 59.91,
  rx: 1.91,
  ry: 1.91
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-18",
  x: 80.24,
  y: 182.02,
  width: 22.65,
  height: 3.66
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-18",
  x: 124.74,
  y: 162.61,
  width: 22.65,
  height: 3.66
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-19",
  x: 77.47,
  y: 182.02,
  width: 22.65,
  height: 3.66
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-19",
  x: 121.97,
  y: 162.61,
  width: 22.65,
  height: 3.66
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-20",
  d: "M84.15,121c7.42,0,6.12-27.87,9.45-27.87s3.19,40.35,10.26,40.35,6.24-30.78,11.65-30.78,4.6,23.29,9.23,23.29,5-32.86,10-32.86,4.79,19.83,8.7,19.83"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M84.15,121c7.42,0,6.12-27.87,9.45-27.87s3.19,40.35,10.26,40.35,6.24-30.78,11.65-30.78,4.6,23.29,9.23,23.29,5-32.86,10-32.86,4.79,19.83,8.7,19.83"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 64.16,
  y1: 71.61,
  x2: 166.22,
  y2: 71.61
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 248.92,
  y1: 71.61,
  x2: 166.22,
  y2: 71.61
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 64.16,
  y1: 213.88,
  x2: 248.92,
  y2: 213.88
}), /*#__PURE__*/React.createElement("path", {
  d: "M207.55,240.51H230V232.3l-7.77-3.48-3.47,3.48-9.38,4.31a3.17,3.17,0,0,0-1.85,2.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-22",
  d: "M233.83,193.33c.91,14.48-.21,39-.21,39H217.43L214.27,162c0-.75-.05-1.49-.07-2.23H200.06V134.15h17.37a48.09,48.09,0,0,1,5.9.26c4.75.59,9.93,2.47,12.84,8.55,1.43,3,2.31,7,2.31,12.41C238.48,169.55,233.23,183.78,233.83,193.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M225.12,178.64c1-3.33,2.4-6.46,3.7-9.68,1.8-4.43,2.9-9.73,1.21-14.37s-11.57-6.53-16.1-6.94a67.68,67.68,0,0,1-4,12.06l0,.09h4.3c0,.74,0,1.48.07,2.23l3.16,70.27h9.8a87.48,87.48,0,0,0,1-10.45,48.51,48.51,0,0,0-1.64-12.57C224.81,202.3,220.55,193.64,225.12,178.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M225.12,178.64c1-3.33,2.4-6.46,3.7-9.68,1.8-4.43,2.9-9.73,1.21-14.37s-11.57-6.53-16.1-6.94a67.68,67.68,0,0,1-4,12.06l0,.09h4.3c0,.74,0,1.48.07,2.23l3.16,70.27h9.8a87.48,87.48,0,0,0,1-10.45,48.51,48.51,0,0,0-1.64-12.57C224.81,202.3,220.55,193.64,225.12,178.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M225.12,178.64c1-3.33,2.4-6.46,3.7-9.68,1.8-4.43,2.9-9.73,1.21-14.37s-11.57-6.53-16.1-6.94a67.68,67.68,0,0,1-4,12.06l0,.09h4.3c0,.74,0,1.48.07,2.23l3.16,70.27h9.8a87.48,87.48,0,0,0,1-10.45,48.51,48.51,0,0,0-1.64-12.57C224.81,202.3,220.55,193.64,225.12,178.64Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.63,240.51H213.1V232.3l-7.77-3.48-3.47,3.48-9.38,4.31a3.17,3.17,0,0,0-1.85,2.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-22",
  d: "M197.56,159.8c0,.74,0,1.48.07,2.23l-4.09,27.75a8.37,8.37,0,0,0,0,2.18L198,232.3h16.74l-3.12-40.08c7-22.44,15.41-42.18,11.44-52.11l-22.29-6H183.42V159.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-24",
  d: "M201.73,229.37c-2.78-21.59-4.2-39.39-4.2-39.39s10.21-26.82,10.3-37.39c.06-7-7.69-8.57-7.69-8.57"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-25",
  d: "M222,228.82c-1.11-21-1.42-38.84-1.42-38.84s4.62-16.67,6.62-28.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-24",
  d: "M199,154.25s0,5.55,6.19,5.09"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-25",
  d: "M213.24,146.8,215,152l6.42,2,3.33-3.64s-.65-7.09-3.33-9.86"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-25",
  points: "226.8 140.11 229.7 148.71 236.12 150.74 237.95 148.74"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-26",
  d: "M236.17,143c-12.06,3.27-29.51,12-36.11,15.44-1.69.87-2.67,1.4-2.67,1.4l2.67-15.32.08-.46,23.19-9.61C228.08,135,233.26,136.88,236.17,143Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-26",
  d: "M236.17,143c-12.06,3.27-29.51,12-36.11,15.44-1.69.87-2.67,1.4-2.67,1.4l2.67-15.32.08-.46,23.19-9.61C228.08,135,233.26,136.88,236.17,143Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-26",
  d: "M236.17,143c-12.06,3.27-29.51,12-36.11,15.44-1.69.87-2.67,1.4-2.67,1.4l2.67-15.32.08-.46,23.19-9.61C228.08,135,233.26,136.88,236.17,143Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M183.42,131.79s37.17-3.82,49.37,6.55c-22.89,10.37-35.23,21.46-35.23,21.46H183.42Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-24",
  x1: 197.78,
  y1: 229.41,
  x2: 214.71,
  y2: 229.41
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-24",
  x1: 217.19,
  y1: 229.41,
  x2: 234.13,
  y2: 229.41
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M210.78,131.61h0l-.4,0,.4,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M208.32,131.41l1.6.13a163.16,163.16,0,0,0-26.5.25v28h14C196.2,148.92,203.27,137.81,208.32,131.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M210,131.55h-.11l.46,0Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-29",
  x: 40.11,
  y: 229.97,
  width: 14.77,
  height: 24.18,
  rx: 1.15,
  ry: 1.15
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-16",
  cx: 47.49,
  cy: 237.99,
  r: 3.51
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-13",
  cx: 242.36,
  cy: 225.84,
  r: 3.51
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M47.49,238l.75,3a22,22,0,0,1,.64,5.24v20.25a4,4,0,0,0,4,4h0a4,4,0,0,0,3.93-3.22c1-4.75,3.25-13.09,7.33-13.09"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M242.36,225.84c8.47,0,11.38,6.74,13.46,21.31S257.15,276,266.68,276s8.28-6.15,2-6.14-7.16,5.69-19.8,5.69"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M88.79,117.08a23.41,23.41,0,0,0,7.48-4.27c3.93-3.17,7.18-7,10.62-10.63,3-3.17,6.37-5.57,10.69-6.44,6-1.23,12.1.62,18,1.92a37.11,37.11,0,0,0,9.94.74V83.7a1.81,1.81,0,0,0-1.8-1.8H84a1.81,1.81,0,0,0-1.8,1.8v33.74A13.65,13.65,0,0,0,88.79,117.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-31",
  d: "M283.08,220.88s-9.65-64.52,0-69.19,6.44,70.45,6.44,70.45,10.38-57.95,16.64-49.36-11.27,48.1-11.27,48.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-32",
  d: "M283.92,219.14s-3.11-46.54-10.57-48.33S279.61,221,279.61,221s-16.1-38.89-19.15-31.94,15.21,31.88,15.21,31.88"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-31",
  d: "M284.53,220.88s9.66-64.52,0-69.19-6.44,70.45-6.44,70.45-10.38-57.95-16.63-49.36,11.27,48.1,11.27,48.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-32",
  d: "M283.7,219.14s3.1-46.54,10.56-48.33S288,221,288,221s16.09-38.89,19.15-31.94S292,220.94,292,220.94"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-19",
  points: "273.72 284.33 291.47 284.33 302.56 218.23 262.62 218.23 273.72 284.33"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-33",
  points: "273.72 284.33 291.47 284.33 302.56 218.23 262.62 218.23 273.72 284.33"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-34",
  points: "283.92 284.33 291.47 284.33 302.56 218.23 291.95 218.23 283.92 284.33"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-29",
  points: "263.71 224.7 263.43 223.04 301.76 223.04 301.48 224.7 263.71 224.7"
}))));

function SvgError(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 356.39 311.32",
    ref: svgRef
  }, props), _ref, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "error.0d42f725f64047954d5f674cd5a8a7ab.svg";
export { ForwardRef as ReactComponent };